import { Card, Typography } from 'antd'
import { useAnswer } from '../../contexts/AnswerContext'
import { useFormEditor } from '../../contexts/FormContext'

const { Text } = Typography

interface Props {}

export const ManagerCommentReadOnly = ({}: Props) => {
  const { manager } = useFormEditor()
  const { item, answer } = useAnswer()

  if (
    manager === undefined ||
    manager === null ||
    item === undefined ||
    !item.isCommentableByManager
  )
    return <></>

  return (
    <Card styles={{ body: { padding: 10 } }}>
      <Text type="secondary">
        Commentaire de {manager.firstName} : {answer?.managerComment}
      </Text>
    </Card>
  )
}

export type ManagerCommentReadOnlyType = {
  ManagerCommentReadOnly: typeof ManagerCommentReadOnly
}
